const MARKET_SESSION_KEY = 'beauty-burst.selected-market-id';

export function selectedAvailableMarketId(
  markets: readonly { readonly id: string }[],
  selectedMarketId: string | null,
): string | null {
  return selectedMarketId !== null && markets.some((market) => market.id === selectedMarketId)
    ? selectedMarketId
    : null;
}

/**
 * The market is a browser-session choice, including for a signed-out visitor.
 * Storage failures (privacy mode, embedded browsers) intentionally degrade to
 * an in-memory selection rather than blocking marketplace use.
 */
export function readSelectedMarketId(): string | undefined {
  try {
    const value = window.sessionStorage.getItem(MARKET_SESSION_KEY);
    return value === null || value.trim() === '' ? undefined : value;
  } catch {
    return undefined;
  }
}

export function writeSelectedMarketId(marketId: string | null): void {
  try {
    if (marketId === null) window.sessionStorage.removeItem(MARKET_SESSION_KEY);
    else window.sessionStorage.setItem(MARKET_SESSION_KEY, marketId);
  } catch {
    // The current in-memory bootstrap selection remains usable.
  }
}
